document.addEventListener("DOMContentLoaded", () => {
  new Swiper(".showcase__slider", {
    slidesPerView: 4,
    spaceBetween: 36,
    loop: false,
    grabCursor: true,
    pagination: {
      el: ".showcase .control__pagination",
      type: "fraction",
    },
    lazy: {
      loadPrevNext: true,
      checkInView: true,
    },
    navigation: {
      nextEl: ".showcase .control__arrow--next",
      prevEl: ".showcase .control__arrow--prev",
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      575: {
        slidesPerView: 2,
        spaceBetween: 12,
      },
      820: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 4,
      },
    },
  });
});
